export default "__VITE_ASSET__DEt_lhoQ__"